module.exports = __webpack_public_path__ + "img/sable_login.b256915d.svg";